module.exports = __webpack_public_path__ + "img/swiper-11.fe6df849.png";